import { DeletedBeneficiary } from '@approvalmax/types';
import { ColumnDefinition, Table, Text } from '@approvalmax/ui/src/components';

import { messages } from './DeletedBeneficiariesPopupContent.messages';

export const columns: ColumnDefinition<DeletedBeneficiary & { id: string }>[] = [
    {
        id: 'beneficiary',
        name: messages.beneficiary,
        value: (li) => li.airwallexBeneficiaryId,
        spacing: '8',
        cellComponent: (props) => (
            <Table.Cell {...props}>
                <Text font='label' fontSize='small' fontWeight='medium' color='red100'>
                    {props.item.beneficiaryName}
                </Text>
            </Table.Cell>
        ),
    },
];
